import { WidgetBase } from '../models';
import { Helper } from '../../common/helpers';

import { SpotManualInputsWidgetDefinition as definition } from './spotManualInputs.definition';
import { SpotManualInputsConfiguration } from './spotManualInputs.configuration';

export class SpotManualInputsWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: SpotManualInputsConfiguration;
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 4;
    sizeY = 12;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = new SpotManualInputsConfiguration();
        if (!this.configuration.taskOptionsOverride) {
            this.configuration.taskOptionsOverride = { includeDependent: true };
        }
    }
}